// source: inv_non_serialized_inventory_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var inv_common_message_pb = require('./inv_common_message_pb.js');
goog.object.extend(proto, inv_common_message_pb);
var inv_non_serialized_inventory_message_pb = require('./inv_non_serialized_inventory_message_pb.js');
goog.object.extend(proto, inv_non_serialized_inventory_message_pb);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.displayName = 'proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
contractName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContractName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string contract_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest.prototype.getContractName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetListByContractRequest.prototype.setContractName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
contractName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContractName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string contract_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest.prototype.getContractName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsRequest.prototype.setContractName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
filter: (f = msg.getFilter()) && inv_common_message_pb.RequestDto.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new inv_common_message_pb.RequestDto;
      reader.readMessage(value,inv_common_message_pb.RequestDto.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      inv_common_message_pb.RequestDto.serializeBinaryToWriter
    );
  }
};


/**
 * optional Olameter.WFMS.InventoryManagement.Common.v1.RequestDto filter = 1;
 * @return {?proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.prototype.getFilter = function() {
  return /** @type{?proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto} */ (
    jspb.Message.getWrapperField(this, inv_common_message_pb.RequestDto, 1));
};


/**
 * @param {?proto.Olameter.WFMS.InventoryManagement.Common.v1.RequestDto|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryListRequest.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
transfer: (f = msg.getTransfer()) && inv_non_serialized_inventory_message_pb.NonSerializedInventoryTransfer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new inv_non_serialized_inventory_message_pb.NonSerializedInventoryTransfer;
      reader.readMessage(value,inv_non_serialized_inventory_message_pb.NonSerializedInventoryTransfer.deserializeBinaryFromReader);
      msg.setTransfer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransfer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      inv_non_serialized_inventory_message_pb.NonSerializedInventoryTransfer.serializeBinaryToWriter
    );
  }
};


/**
 * optional NonSerializedInventoryTransfer transfer = 1;
 * @return {?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.prototype.getTransfer = function() {
  return /** @type{?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer} */ (
    jspb.Message.getWrapperField(this, inv_non_serialized_inventory_message_pb.NonSerializedInventoryTransfer, 1));
};


/**
 * @param {?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransfer|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.prototype.setTransfer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.prototype.clearTransfer = function() {
  return this.setTransfer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryTransferRequest.prototype.hasTransfer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
nonSerializedInventoryName: jspb.Message.getFieldWithDefault(msg, 1, ""),
locationName: jspb.Message.getFieldWithDefault(msg, 2, ""),
adjustmentNote: (f = msg.getAdjustmentNote()) && inv_non_serialized_inventory_message_pb.AdjustmentNote.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonSerializedInventoryName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationName(value);
      break;
    case 3:
      var value = new inv_non_serialized_inventory_message_pb.AdjustmentNote;
      reader.readMessage(value,inv_non_serialized_inventory_message_pb.AdjustmentNote.deserializeBinaryFromReader);
      msg.setAdjustmentNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNonSerializedInventoryName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocationName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAdjustmentNote();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      inv_non_serialized_inventory_message_pb.AdjustmentNote.serializeBinaryToWriter
    );
  }
};


/**
 * optional string non_serialized_inventory_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.prototype.getNonSerializedInventoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.prototype.setNonSerializedInventoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string location_name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.prototype.getLocationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.prototype.setLocationName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AdjustmentNote adjustment_note = 3;
 * @return {?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.prototype.getAdjustmentNote = function() {
  return /** @type{?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote} */ (
    jspb.Message.getWrapperField(this, inv_non_serialized_inventory_message_pb.AdjustmentNote, 3));
};


/**
 * @param {?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.prototype.setAdjustmentNote = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.prototype.clearAdjustmentNote = function() {
  return this.setAdjustmentNote(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryAdjustRequest.prototype.hasAdjustmentNote = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetNonSerializedInventoryByNameRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
nonSerializedInventory: (f = msg.getNonSerializedInventory()) && inv_non_serialized_inventory_message_pb.NonSerializedInventory.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new inv_non_serialized_inventory_message_pb.NonSerializedInventory;
      reader.readMessage(value,inv_non_serialized_inventory_message_pb.NonSerializedInventory.deserializeBinaryFromReader);
      msg.setNonSerializedInventory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNonSerializedInventory();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      inv_non_serialized_inventory_message_pb.NonSerializedInventory.serializeBinaryToWriter
    );
  }
};


/**
 * optional NonSerializedInventory non_serialized_inventory = 1;
 * @return {?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.prototype.getNonSerializedInventory = function() {
  return /** @type{?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} */ (
    jspb.Message.getWrapperField(this, inv_non_serialized_inventory_message_pb.NonSerializedInventory, 1));
};


/**
 * @param {?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.prototype.setNonSerializedInventory = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.prototype.clearNonSerializedInventory = function() {
  return this.setNonSerializedInventory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryRequest.prototype.hasNonSerializedInventory = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
nonSerializedInventory: (f = msg.getNonSerializedInventory()) && inv_non_serialized_inventory_message_pb.NonSerializedInventory.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new inv_non_serialized_inventory_message_pb.NonSerializedInventory;
      reader.readMessage(value,inv_non_serialized_inventory_message_pb.NonSerializedInventory.deserializeBinaryFromReader);
      msg.setNonSerializedInventory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNonSerializedInventory();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      inv_non_serialized_inventory_message_pb.NonSerializedInventory.serializeBinaryToWriter
    );
  }
};


/**
 * optional NonSerializedInventory non_serialized_inventory = 1;
 * @return {?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.prototype.getNonSerializedInventory = function() {
  return /** @type{?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory} */ (
    jspb.Message.getWrapperField(this, inv_non_serialized_inventory_message_pb.NonSerializedInventory, 1));
};


/**
 * @param {?proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.prototype.setNonSerializedInventory = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.prototype.clearNonSerializedInventory = function() {
  return this.setNonSerializedInventory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryResponse.prototype.hasNonSerializedInventory = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
nonSerializedInventoriesList: jspb.Message.toObjectList(msg.getNonSerializedInventoriesList(),
    inv_non_serialized_inventory_message_pb.NonSerializedInventory.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new inv_non_serialized_inventory_message_pb.NonSerializedInventory;
      reader.readMessage(value,inv_non_serialized_inventory_message_pb.NonSerializedInventory.deserializeBinaryFromReader);
      msg.addNonSerializedInventories(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNonSerializedInventoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      inv_non_serialized_inventory_message_pb.NonSerializedInventory.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NonSerializedInventory non_serialized_inventories = 1;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory>}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.prototype.getNonSerializedInventoriesList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory>} */ (
    jspb.Message.getRepeatedWrapperField(this, inv_non_serialized_inventory_message_pb.NonSerializedInventory, 1));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.prototype.setNonSerializedInventoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.prototype.addNonSerializedInventories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryListResponse.prototype.clearNonSerializedInventoriesList = function() {
  return this.setNonSerializedInventoriesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    inv_non_serialized_inventory_message_pb.NonSerializedInventory.toObject, includeInstance),
total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new inv_non_serialized_inventory_message_pb.NonSerializedInventory;
      reader.readMessage(value,inv_non_serialized_inventory_message_pb.NonSerializedInventory.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      inv_non_serialized_inventory_message_pb.NonSerializedInventory.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated NonSerializedInventory data = 1;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory>}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory>} */ (
    jspb.Message.getRepeatedWrapperField(this, inv_non_serialized_inventory_message_pb.NonSerializedInventory, 1));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryDataSourceResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
adjustmentNotesList: jspb.Message.toObjectList(msg.getAdjustmentNotesList(),
    inv_non_serialized_inventory_message_pb.AdjustmentNote.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new inv_non_serialized_inventory_message_pb.AdjustmentNote;
      reader.readMessage(value,inv_non_serialized_inventory_message_pb.AdjustmentNote.deserializeBinaryFromReader);
      msg.addAdjustmentNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdjustmentNotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      inv_non_serialized_inventory_message_pb.AdjustmentNote.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AdjustmentNote adjustment_notes = 1;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote>}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.prototype.getAdjustmentNotesList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote>} */ (
    jspb.Message.getRepeatedWrapperField(this, inv_non_serialized_inventory_message_pb.AdjustmentNote, 1));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.prototype.setAdjustmentNotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.prototype.addAdjustmentNotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNote, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.AdjustmentNoteListResponse.prototype.clearAdjustmentNotesList = function() {
  return this.setAdjustmentNotesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.toObject = function(includeInstance, msg) {
  var f, obj = {
warningKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
nonSerializedInventoryName: jspb.Message.getFieldWithDefault(msg, 2, ""),
item: jspb.Message.getFieldWithDefault(msg, 3, ""),
countRemaining: jspb.Message.getFieldWithDefault(msg, 4, 0),
threshold: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWarningKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonSerializedInventoryName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setItem(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCountRemaining(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setThreshold(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWarningKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNonSerializedInventoryName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getItem();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCountRemaining();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getThreshold();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string warning_key = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.prototype.getWarningKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.prototype.setWarningKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string non_serialized_inventory_name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.prototype.getNonSerializedInventoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.prototype.setNonSerializedInventoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string item = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.prototype.getItem = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.prototype.setItem = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 count_remaining = 4;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.prototype.getCountRemaining = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.prototype.setCountRemaining = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 threshold = 5;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.prototype.getThreshold = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.prototype.setThreshold = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
issueCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
warningsList: jspb.Message.toObjectList(msg.getWarningsList(),
    proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse;
  return proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIssueCount(value);
      break;
    case 2:
      var value = new proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.deserializeBinaryFromReader);
      msg.addWarnings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssueCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getWarningsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 issue_count = 1;
 * @return {number}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.prototype.getIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.prototype.setIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated LowStockWarning warnings = 2;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning>}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.prototype.getWarningsList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning, 2));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse} returns this
*/
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.prototype.setWarningsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning}
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.prototype.addWarnings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.LowStockWarning, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse} returns this
 */
proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.GetLowStockWarningsResponse.prototype.clearWarningsList = function() {
  return this.setWarningsList([]);
};


goog.object.extend(exports, proto.Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1);
